<forge-scaffold>
    <image-cropper #imageCropper slot="body" [maintainAspectRatio]="false" (imageCropped)="imageCropped($event)"
                    [allowMoveImage]="true" output="base64" format="jpeg" [imageBase64]="data.photo" [onlyScaleDown]="true">
    </image-cropper>

    <forge-toolbar slot="footer">
        <command-bar slot="end" [commands]="commands"></command-bar>
    </forge-toolbar>
</forge-scaffold>
